import axios from 'axios';
import { API } from "aws-amplify";

export class FileUpload {
  dataVersionId;
  scheduleVersionIds;
  schoolId;
  apiName;
  interval;
  progressUpdateInterval;
  constructor(dataVersionId, scheduleVersionIds, schoolId) {
    this.dataVersionId = dataVersionId;
    this.scheduleVersionIds = scheduleVersionIds;
    this.schoolId = schoolId;
    this.apiName = process.env.REACT_APP_ENDPOINT_NAME
  }
  cancelCheck(cancelInterpolation = true) {
    if (this.interval !== undefined) {
      clearInterval(this.interval);
      this.interval = undefined;
    };

    // if (cancelInterpolation && this.progressUpdateInterval !== undefined) {
    //   clearInterval(this.progressUpdateInterval);
    //   this.progressUpdateInterval = undefined;
    // }
  }

  async getSchoolProcesses(scheduleYearID) {
      const apiName = process.env.REACT_APP_ENDPOINT_NAME;
      const myInit = {
        response: true,
        queryStringParameters: { 
          school_id: this.schoolId,
          schedule_year_id: scheduleYearID
        }
      }
      const url = '/process/check-progress';
      
      const response = await API.get(apiName, url, myInit);
      const responseData = response.data;

      return responseData;
  }

  async checkUploading(schoolID, progressID, eventCB) {
    if (this.interval !== undefined) return;

    const check = async () => {
      const apiName = process.env.REACT_APP_ENDPOINT_NAME;
      const myInit = {
        response: true,
        queryStringParameters: { 
          school_id:schoolID,
          progress_id: progressID
        }
      };
      const url = '/process/check-progress';
      
      const response = await API.get(apiName, url, myInit);
      const responseData = response.data[0];
      const progress = responseData.progress;
      const isDone = responseData.is_done;
      const failure = responseData.failure;
      const has_feedback = responseData.has_feedback;

      eventCB({
        has_started: responseData.has_started,
        done: isDone,
        failure: failure,
        has_feedback: has_feedback,
        progress: progress ?? 0
      });

      if(responseData.has_feedback || responseData.is_done || responseData.failure) {
        this.cancelCheck();
        return false;
      }

      return true;
    };

    const shouldContinue = await check();
    if (!shouldContinue) return;
    this.interval = setInterval(check, 5000, false);
  }

  async uploadFile(srcFile, uploadType, isReplace = false, eventCB) {
    const apiName = process.env.REACT_APP_ENDPOINT_NAME;
    const myInit = {
			response: true,
			queryStringParameters: {
				upload_type: uploadType,
				data_version_id: this.dataVersionId,
				schedule_version_ids: this.scheduleVersionIds,
				content_type: srcFile.type,
				school_id: this.schoolId,
        replace: isReplace
			}
		};

		const url = '/generate-upload-url';
    const response = await API.get(apiName, url, myInit);
    //TODO: Check repsonse here for success
    const responseData = response.data;
		const uploadToUrl = responseData.url;
    const uploadFields = responseData.fields;
    const formData = new FormData();
		for(let i = 0, keys = Object.keys(uploadFields); i < keys.length; ++i) {
			const key = keys[i];
			const value = uploadFields[key];
			formData.append(key, value);
		}
		formData.append('Content-Type', srcFile.type);
    formData.append('file', srcFile);
    const uploadResponse = await axios.request({
      method: 'post',
      url: uploadToUrl,
      data: formData,
      onUploadProgress: (event) => {
        eventCB({progress: event.loaded / event.total});
      }
    });
    if (uploadResponse.status === 204) {
      return true;
    } else {
      return false;
    }
  }
}
